// import { authHeader } from './auth-header';
import { base } from '../base';


async function getListUser(param) {
  return base.get('accounts', param)
}


export const userService = {
  getListUser
}